import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React from 'react';
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import GlobalHelper from '../common/GlobalHelper.jsx';
import Icon from "../common/icon/icon.component.jsx";

function ChoosePlanPlan(props) {

    const isSelected = props.selectedPlan === props.p.id
    const price = props.formatPrice(props.p.price)
    const isDefaultLanguageEN = AppContext.getAccount().attributes.defaultLanguage.includes("en")
    const onClick = () => {
        props.choosePlan(props.p.id)
    }

    return (<div className={"card px-0 col-lg-3 col-md-4 col-12 mr-4 px-0 mt-2 " + (isSelected ? ' border-success' : '')} key={props.key}>

        <h3 className={"card-title text-center border-bottom py-2 custom-lead text-white mb-0 " + (isSelected ? ' bg-success' : 'bg-secondary')}>
            {isDefaultLanguageEN ? props.p.nameEnglish : props.p.nameFrench}
        </h3>
        <div className="card-body card-text text-center price mb-0 custom-lead p-2 pt-0" style={{ maxHeight: '75px' }}>
            {price > 0 ?
                <span className="d-flex justify-content-center align-items-center">
                    <FormattedNumber
                        style="currency"
                        maximumFractionDigits={0}
                        currencyDisplay={'symbol'}
                        currency={props.currency}
                        value={props.formatPrice(props.p.price)}
                    />
                    <small>
                        {props.p.intervalType == 'month' ?
                            <small>
                                <FormattedMessage
                                    id="myaccount.subscription.monthly_price_unit"
                                    defaultMessage="/month"
                                />
                            </small> :

                            <small>
                                <FormattedMessage
                                    id="myaccount.subscription.yearly_price_unit"
                                    defaultMessage="/year"
                                />
                            </small>
                        }
                    </small>
                </span> : <FormattedMessage
                    id="myaccount.subscription.free"
                    defaultMessage="Free"
                />}

        </div>
        <div className={"card-body d-flex flex-column justify-content-between p-2"}>
            <div className={'w-100'} style={{ minHeight: '350px' }}>
                <div className="card-text w-100 text-center border-top py-2" >
                    {props.p.descriptionEnglish || props.p.descriptionFrench ?
                        <div className={'w-100'} style={{ minHeight: '350px',whiteSpace: "pre-line" }}>
                            {isDefaultLanguageEN ? props.p.descriptionEnglish : props.p.descriptionFrench}
                        </div>
                        :
                        <>
                            <strong>
                                <FormattedMessage
                                    id="myaccount.choose_plan.documents_limit"
                                    defaultMessage="{nb} sales per month"
                                    values={{
                                        nb: parseFloat(props.p.document_limit) == 0 ? <FormattedMessage
                                            id="myaccount.choose_plan.unlimited"
                                            defaultMessage="Unlimited" /> : <FormattedMessage
                                            id="myaccount.choose_plan.up_to"
                                            defaultMessage="Up to {nb}"
                                            values={{ nb: props.p.document_limit }} />
                                    }} />
                            </strong><br /><strong>
                                <FormattedMessage
                                    id="myaccount.choose_plan.number_users"
                                    defaultMessage="{nb} Users"
                                    values={{
                                        nb: parseFloat(props.p.maxNumberOfUsers) == 0 ? <FormattedMessage
                                            id="myaccount.choose_plan.unlimited"
                                            defaultMessage="Unlimited" /> : <FormattedMessage
                                            id="myaccount.choose_plan.up_to"
                                            defaultMessage="Up to {nb}"
                                            values={{ nb: props.p.maxNumberOfUsers }} />
                                    }} />
                            </strong><div className={'mt-2 mb-0 '}>
                                {props.getModulesMessages()
                                    .filter(m => !m.hidden)
                                    .map((m, index) => {
                                        return (props.p.features.includes(m.module) &&
                                            <div key={index}>
                                                <span>
                                                    {m.message}
                                                </span>
                                                <br />
                                            </div>);
                                    })}
                            </div>
                        </>
                    }
                </div>

                {!GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() && props.p.displayDescriptionFooter &&
                    <div className="card-text text-center mb-0">
                        <small>
                            <FormattedMessage
                                id="myaccount.choose_plan.bank_transfer"
                                defaultMessage="{fee}{amount}{cap}"
                                values={{
                                    fee: props.p.bankTransferFeePercentage && parseFloat(props.p.bankTransferFeePercentage) > 0 ? <FormattedMessage
                                        id="myaccount.choose_plan.bank_transfer.ach_fee"
                                        defaultMessage="{nb}% ACH fee"
                                        values={{ nb: props.p.bankTransferFeePercentage }}
                                    /> : " ",
                                    amount: props.p.bankTransferFeeAmount && parseFloat(props.p.bankTransferFeeAmount) > 0 ? <FormattedMessage
                                        id="myaccount.choose_plan.bank_transfer.ach_amount"
                                        defaultMessage="+ ${nb} per transaction"
                                        values={{ nb: props.p.bankTransferFeeAmount }}
                                    /> : " ",
                                    cap: props.p.bankTransferFeeCap && parseFloat(props.p.bankTransferFeeCap) > 0 ? <FormattedMessage
                                        id="myaccount.choose_plan.bank_transfer.ach_cap"
                                        defaultMessage="/ {nb}$ cap"
                                        values={{ nb: props.p.bankTransferFeeCap }}
                                    /> : " ",
                                }}
                            />
                        </small>
                    </div>
                }
            </div>
            <div >
                <div className="card-text text-center border-top py-2 mb-0 mt-2">
                    <input type={'radio'} checked={isSelected} onChange={onClick} />
                </div>
                <div className="card-text text-center mb-2">
                    <button className={"btn btn-primary padding-left-0-for-inner-span" + (isSelected ? ' btn-success' : ' btn-secondary')} onClick={onClick}>
                        {isSelected ? <FormattedMessage
                            id="myaccount.choose_plan.selected_btn"
                            defaultMessage="Selected"
                        /> : <FormattedMessage
                            id="myaccount.choose_plan.choose_btn"
                            defaultMessage="Choose"
                        />}
                        {isSelected ? <Icon className={'ml-1'} value={'check'} /> : ''}
                    </button>
                </div>
            </div>
        </div>


    </div >);
}

export default injectIntl(ChoosePlanPlan);


// WEBPACK FOOTER //
// ./src/my-account/chooseplanplan.component.jsx